<template>
    <v-container>
        <v-card-title class="justify-center">
        Registration Complete
        </v-card-title>
        <v-card-text>
            <sweetalert-icon icon="success" />  
        </v-card-text>

    </v-container>
</template>

<script>
import Vue from 'vue'

import SweetAlertIcons from 'vue-sweetalert-icons';

Vue.use(SweetAlertIcons);
// ```
// If you're using Nuxt, you might need additional steps [(read more)](#usage-with-nuxt)

// ## Use
// ```vue
// <template>
//     <!-- Icon can be one of: "success", "warning", "info", "error" and "loading" -->

//     <!-- Optionally, you can customize colors for all icons! 🎨 -->
//     <sweetalert-icon icon="warning" color="#6a737d"/>
// </template>


export default {
    data() {
        return {
            isLoading: true,
            isComplete: false,
            isError: false
        }
    },
    methods: {
        activate() {
            setTimeout(() => this.$router.push('/login'), 2000);
        }

    },
    mounted() {
        this.activate()
    },

}
</script>

<style>

</style>